import { IsServerSideRendering } from '../utilities';
import ApplicationSettings from './ApplicationSettings';

const noop = () => undefined;

function setGlobal(key, val) {
  if (IsServerSideRendering) return;
  window[key] = val;
  // eslint-disable-next-line consistent-return
  return window[key];
}

function loadExternalScript(url, globalProp, callback = noop) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.onload = async () => {
      const result = await callback(window[globalProp]);
      if (result && !window[globalProp]) {
        setGlobal(globalProp, result);
      }
      resolve(window[globalProp]);
    };
    script.onerror = reject;
    script.src = url;
    document.body.appendChild(script);
  });
}

const getExternalScriptClient = (globalProp, url, callback = noop) => {
  if (!globalProp || IsServerSideRendering) {
    return undefined;
  }
  if (url && !window[globalProp]) {
    return loadExternalScript(url, globalProp, callback).catch(() => null);
  }

  callback(window[globalProp]);
  return window[globalProp];
};

function getClient(id) {
  return getExternalScriptClient(
    'dataLayer',
    `https://www.googletagmanager.com/gtm.js?id=${id}`
  );
}

class GoogleTagManagerClient {
  setup() {
    if (IsServerSideRendering) return;

    this.googleTagManagerContainerId = ApplicationSettings.getApplicationSetting('googleTagManagerContainerId');
  }

  trackEvent = async (eventData = {}) => {
    if (IsServerSideRendering) return;

    const trackConversionGoogleTagManager = await getClient(this.googleTagManagerContainerId);
    trackConversionGoogleTagManager.push({ ...eventData });
  }
}

export default new GoogleTagManagerClient();
